(() => {
  angular
    .module('complianceFrameworkApp.complianceServices')
    .controller('ComplianceServicesDashboardController', ComplianceServicesDashboardController);

  /* ngInject */
  function ComplianceServicesDashboardController(bannerService, config, dashboardService, sessionService) {
    const vm = this;

    vm.activate = activate;
    vm.articlesCount = 0;
    vm.banners = [];
    vm.config = config;
    vm.displayNameForType = displayNameForType;
    vm.eventsCount = 0;
    vm.featured = [];
    vm.getBanners = getBanners;
    vm.getDashboard = getDashboard;
    vm.helpfulResourcesCount = 0;
    vm.iconForType = iconForType;
    vm.loading = false;
    vm.manualsCount = 0;
    vm.consultations = [];
    vm.policyTemplatesCount = 0;
    vm.quickGuidesCount = 0;
    vm.recentContent = [];
    vm.upcomingEvents = [];
    vm.webinarsCount = 0;
    vm.checkListsCount = 0;

    vm.activate();

    function activate() {
      vm.getDashboard();
      vm.getBanners();
    }

    function displayNameForType(type) {
      switch(type) {
      case 'article':
        return 'Article';
      case 'manual':
        return 'Manual';
      case 'webinar':
        return 'Webinar';
      case 'quick_guide':
        return 'Quick Guide';
      case 'policy_template':
        return 'Policy Template';
      case 'event':
        return 'Event';
      case 'helpful_resource':
        return 'Helpful Resource';
      case 'check_list':
        return 'Check List';
      }
    }

    function getBanners() {
      bannerService(sessionService.getAuthToken()).query(response => vm.banners = response);
    }

    function getDashboard() {
      vm.loading = true;
      dashboardService(sessionService.getAuthToken()).query(_getDashboardSuccess);
    }

    function iconForType(type) {
      switch(type) {
      case 'article':
        return 'glyphicons-newspaper';
      case 'manual':
        return 'glyphicons-log-book';
      case 'webinar':
        return 'glyphicons-keynote';
      case 'quick_guide':
        return 'glyphicons-list-alt';
      case 'policy_template':
        return 'glyphicons-article';
      case 'event':
        return 'glyphicons-calendar';
      case 'helpful_resource':
        return 'glyphicons-info-sign';
      case 'check_list':
        return 'glyphicons-check';
      }
    }

    function _getDashboardSuccess(response) {
      vm.loading = false;
      vm.featured = response.featured;
      vm.consultations = response.consultations;
      vm.upcomingEvents = response.upcoming_events;
      vm.articlesCount = response.articles_count;
      vm.manualsCount = response.manuals_count;
      vm.webinarsCount = response.webinars_count;
      vm.eventsCount = response.events_count;
      vm.policyTemplatesCount = response.policy_templates_count;
      vm.quickGuidesCount = response.quick_guides_count;
      vm.helpfulResourcesCount = response.helpful_resources_count;
      vm.checkListsCount = response.check_lists_count;
    }
  }
})();
